import { RydeAdminUnit } from "../models";

export const manualAdminFilters: Partial<Record<RydeAdminUnit, string[]>> = {
  globalConfig: ["name"],
  formSchema: ["entityTitle"],
  gridSchema: ["entityTitle"],
  fieldType: ["name"],
  role: ["name"],
  permission: ["id", "entityTitle", "action", "description"],
  company: ["id", "name", "code", "dbName", "dbStructure"],
  customField: [
    "id",
    "companyTitle",
    "entityTitle",
    "filterFieldTypeTitle",
    "name",
  ],
} as const;
